import { NSARouterMakerResult } from "namirasoft-account-react";
import { JournalEntryFullRow } from "namirasoft-erp";
import { Component } from "react";
import { ErpRouterProps } from "../ErpRouterProps";
import { JournalEntryLinesView } from "./JournalEntryLinesView";

interface JournalEntryLinesViewLoaderProps extends NSARouterMakerResult, ErpRouterProps
{
    journal_entry_id: string;
}

interface JournalEntryLinesViewLoaderState
{
    row: JournalEntryFullRow | null;
}

export class JournalEntryLinesViewLoader extends Component<JournalEntryLinesViewLoaderProps, JournalEntryLinesViewLoaderState>
{
    override state: JournalEntryLinesViewLoaderState = { row: null };

    override componentDidMount(): void { this.load(); }

    override componentDidUpdate(prev: JournalEntryLinesViewLoaderProps): void
    {
        if (prev.journal_entry_id !== this.props.journal_entry_id) this.load();
    }

    private async load(): Promise<void>
    {
        let { journal_entry_id: id } = this.props;
        if (!id) { this.setState({ row: null }); return; }
        try
        {
            let row = await this.props.servers.erp.journal_entry.Get(id);
            this.setState({ row });
        }
        catch (e) { console.error(e); }
    }

    override render()
    {
        let { row } = this.state;
        if (!row)
            return null;

        let lines = row.lines ?? [];
        let firstCurrencyId = lines.find((r) => !!r.currency_id)?.currency_id ?? "";
        let isMulti = lines.some((r) => r.currency_id && r.currency_id !== firstCurrencyId);
        let entryCurrencyId = isMulti ? "" : firstCurrencyId;

        return (
            <JournalEntryLinesView
                {...this.props}
                journal_entry_id={this.props.journal_entry_id}
                currency_id={entryCurrencyId}
                rows={lines}
            />
        );
    }
}